import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

interface CardActionButtonProps {
    active: boolean;
    deactivateModuleAt?: string | null;
    createdAt: string;
    oneTimeFeeBilledOnce: boolean;
    trialIsActive: boolean;
    isWebsiteIntegrationModule: Boolean;
    onClick: () => void;
}

export const CardActionButton = ({
    onClick,
    active,
    createdAt,
    deactivateModuleAt,
    oneTimeFeeBilledOnce,
    trialIsActive,
    isWebsiteIntegrationModule,
}: CardActionButtonProps) => {
    const { t } = useTranslation();

    // Handle the case where deactivateAt is undefined or null

    if (isWebsiteIntegrationModule)
        return (
            <button className={`btn card-button ${active ? 'deactivate' : 'activate'}`} disabled={true}>
                {active ? t('modules_store.deactivate') : t('modules_store.activate')}
            </button>
        );

    if (deactivateModuleAt != null && !trialIsActive)
        return <p>{t('modules_store.active_until', { date: moment(deactivateModuleAt).format('DD.MM.YYYY') })}</p>;

    if (trialIsActive)
        return (
            //TODO replace translation keys
            <button className={`btn card-button ${active ? 'deactivate' : 'activate'}`} disabled={true}>
                {t('modules_store.trial_active')}
            </button>
        );
    return (
        <>
            {/* Use a fragment to avoid extra DOM elements */}
            <button
                className={`btn card-button ${active ? 'deactivate' : 'activate'}`}
                onClick={e => {
                    e.stopPropagation();
                    onClick();
                }}>
                {active ? t('modules_store.deactivate') : t('modules_store.activate')}
            </button>
        </>
    );
};
